<template>
    <form class="form-horizontal" v-if="config">
        <div class="form-group">
            <label for="tempo_parado" class="col-sm-2 control-label">TEMPO PARADO:</label>
            <div class="col-sm-3">
                <input type="text" v-model="config.tempo_parado" class="form-control" id="tempo_parado">
            </div>
            <label for="tempo_dirigindo" class="col-sm-2 control-label">TEMPO DIRIGINDO:</label>
            <div class="col-sm-2">
                <input type="text" v-model="config.tempo_dirigindo"  class="form-control" id="tempo_dirigindo" >
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <button @click="send()" type="button" class="btn btn-xs btn-success">
                    <i class="fa fa-save"></i> ENVIAR Tempo
                </button>
            </div>
        </div>
    </form>
</template>
<script>
    import {Suntech} from "../../../../../class";
    import {Bus} from '../../../../../class/bus';
    export default {
        name: "Tempo4g",
        props: {
            config: {
                "default": null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Suntech.sendTempos(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.log(err);
                        return toastr.error("Conexao não enviada!");
                    }
                });
            }
        }
    };
</script>
